import type { TFunction } from 'i18next';

import { z } from 'zod';

export const simplePasswordSchema = (t: TFunction) =>
  z.string().min(8, t('Form.FormErrorPasswordMinimumLength'));

export const passwordSchema = (t: TFunction) =>
  simplePasswordSchema(t).regex(
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?!.* )(?=.*[\W_])[A-Za-z\d\W_]{8,}$/,
    t('Form.FormErrorPasswordMatches'),
  );

export const emailSchema = (t: TFunction) =>
  z
    .email(t('Form.FormErrorEnterValidEmail'))
    .min(1, t('Form.FormErrorEmailIsRequired'));
